<template>
<div class="r-registry-tab">
    <slot></slot>
</div>
</template>

<script>
export default {
    name: 'Tab',
    components: {},
    props: {
        title: {
            type: String,
            required: true
        }
    },
    data() {
        return {}
    },
    mounted() { },
    methods: {}
}
</script>
